import { useEffect, useRef } from 'react';
// 仅订阅来源导航，不绕过统一导航代理。
// eslint-disable-next-line ban/ban
import { useRouter } from 'next/router';
import { requestMyIpAssetReturn, type MyIpAssetReturnRequest } from '$/domains/myIp/returnState';
import {
  consumeMyIpReturnState, firstMyIpReturnQueryValue, isMyIpTeamStudioReturnHref, isMyIpAssetsReturnHref, MY_IP_RESTORE_QUERY,
} from '@/utils/myIp/backNavigation';
import { useMyIpSession } from '@/hooks/myIp/useMyIpSession';

/** 登录与来源匹配后通知对应资产宿主恢复；无有效 token 不创建任何 UI 或业务操作。 */
export default function MyIpReturnStateHost() {
  // eslint-disable-next-line ban/ban
  const router = useRouter();
  const session = useMyIpSession();
  const token = firstMyIpReturnQueryValue(router.query[MY_IP_RESTORE_QUERY]);
  const handoff = useRef<{ key: string; request: MyIpAssetReturnRequest; }>();
  useEffect(() => {
    if (!session.enabled || !router.isReady
      || (!isMyIpTeamStudioReturnHref(router.asPath) && !isMyIpAssetsReturnHref(router.asPath))) {
      handoff.current = undefined;
      return undefined;
    }
    const key = JSON.stringify([session.scopeKey, token, router.asPath]);
    if (handoff.current?.key !== key) handoff.current = undefined;
    const source = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const state = consumeMyIpReturnState(token, session.scopeKey, source);
    if (state?.kind === 'asset') handoff.current = { key, request: { scopeKey: session.scopeKey, state } };
    return handoff.current?.key === key ? requestMyIpAssetReturn(handoff.current.request) : undefined;
  }, [token, session.enabled, session.scopeKey, router.isReady, router.asPath]);
  return null;
}
